import React, { useCallback, useState } from "react"
import { createPortal } from "react-dom"
import styled from "styled-components"

import { Card } from "../components/ui-parts/Card"

import { styleTheme } from "../style/theme";

export function useModal(closeCallback?: () => void) {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const open = useCallback(() => {
    setIsOpen(true)
  }, [setIsOpen])
  const close = useCallback(() => {
    setIsOpen(false)
    if (closeCallback) {
      closeCallback()
    }
  }, [setIsOpen, closeCallback])

  const Modal = useCallback(
    (props) => <StyledComponent theme={styleTheme} isOpen={isOpen} close={close} {...props} />,
    [isOpen, close]
  )

  return {
    Modal,
    open,
    close,
    isOpen,
  }
}

const Component: React.FC<any> = (props) => {
  if (!props.isOpen) {
    return null
  }
  return createPortal(
    <div className={props.className}>
      <div onClick={props.close} className={`${props.className}_overlay`}></div>
      <div className={`${props.className}_content`}>
        <Card align="left" title={props.title} primaryColor={props.primaryColor} color="teal">
          <div className={`${props.className}_body`}>
            {props.children}
          </div>
        </Card>
        <span
          className={`${props.className}_closeButton`}
          onClick={() => props.close()}
        ></span>
      </div>
    </div>,
    document.getElementById("modal-root")
  )
}

const StyledComponent = styled(Component)`
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3;

  &_overlay {
    background-color: #fff;
    opacity: 0.8;
    height: 100%;
    width: 100%;
  }

  &_content {
    background-color: #fff;
    border-radius: 8px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    position: fixed;
    min-width: 857px;

    @media screen and (max-width: 1000px) {
      width: 90%;
      min-width: 300px;
    }
  }

  &_bottom {
    border-top: 1px solid #ccc;
    padding: 15px;
    display: flex;
    justify-content: flex-end;
  }

  &_submit {
    margin-left: 30px;
  }

  &_body {
    margin: -32px -64px 0;
    max-height: 75vh;
    overflow: scroll;
  }

  &_closeButton {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => props.theme.colors.white};
    width: 60px;
    height: 60px;
    border-radius: 100px;
    box-shadow: 0 0 15px -5px ${(props) => props.theme.colors.gray.base};
    right: calc(50% - 450px);
    top: calc(50% - 40vh - 60px);
    z-index: 10000;
    cursor: pointer;
    @media screen and (max-width: 1000px) {
      right: calc(5% - 40px);
    }

    &::before,
    &::after {
      content: "";
      position: absolute;
      left: calc(50% - 19px);
      top: calc(50% - 1px);
      display: block;
      width: 40px;
      height: 2px;
      background-color: ${(props) => props.primaryColor};
      transform: rotate(45deg);
    }

    &::after {
      transform: rotate(-45deg);
    }
  }
`
